<template>
  <Modal
    :title="modalTitle"
    :saving="saving"
    :deleting="deleting"
    saving-text="Saving..."
    @submit="handleSaveNote"
    @hide-modal="$emit('hide-modal')"
    @delete="handleDeleteNote"
  >
    <div class="form-group">
      <TextArea
        v-model="notes"
        name="note"
        class="full-width"
        :label="noteLabel"
        :hint-label="noteHintLabel"
        :rows="3"
        :validation-errors="v$.$errors"
      />
    </div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    Modal,
    TextArea
  },
  props: {
    transaction: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      notes: this.transaction.notes || "",
      saving: false,
      deleting: false
    };
  },
  computed: {
    modalTitle() {
      return `Edit ${this.transactionType} Note`;
    },
    transactionType() {
      return this.transaction.amount_cents < 0 ? "Refund" : "Payment";
    },
    noteLabel() {
      return `${this.transactionType} Note`;
    },
    noteHintLabel() {
      return `(Add Details About This ${this.transactionType})`;
    }
  },
  validations() {
    return {
      notes: { required, $autoDirty: true }
    };
  },
  methods: {
    ...mapActions(["updateInvoiceNote"]),
    handleSaveNote() {
      this.v$.$validate().then((valid) => {
        if (!valid) return;
        this.saving = true;
        this.updateInvoiceNote({
          ...this.transaction,
          notes: this.notes
        })
          .then(() => this.showSuccessMessage("Updated"))
          // Errors are surfaced to the user by the global axios interceptor;
          // reset the saving state either way so the modal never hangs.
          .catch(() => {})
          .finally(() => {
            this.saving = false;
          });
      });
    },
    handleDeleteNote() {
      this.deleting = true;
      this.updateInvoiceNote({
        ...this.transaction,
        notes: ""
      })
        .then(() => this.showSuccessMessage("Deleted"))
        .catch(() => {})
        .finally(() => {
          this.deleting = false;
        });
    },
    showSuccessMessage(action) {
      this.$emit("hide-modal");
      window.notify.success(
        `${this.transactionType} Note ${action} Successfully`
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
